import {
  MonolithBoardModal,
  MONOLITH_BOARD_MODAL_TITLE_CLASS,
} from "@/components/dashboard/MonolithBoardModal";
import { Button } from "@/components/ui/Button";

interface RemovedFromCampaignModalProps {
  open: boolean;
  campaignName: string | null;
  onClose: () => void;
}

const TITLE_ID = "removed-from-campaign-modal-title";

export default function RemovedFromCampaignModal({
  open,
  campaignName,
  onClose,
}: RemovedFromCampaignModalProps) {
  const safeName = campaignName?.trim() ? campaignName.trim() : "this campaign";

  return (
    <MonolithBoardModal open={open} titleId={TITLE_ID} onClose={onClose}>
      <div className="flex items-start justify-between gap-4">
        <h2 id={TITLE_ID} className={MONOLITH_BOARD_MODAL_TITLE_CLASS}>
          Removed from campaign
        </h2>
      </div>
      <p className="mt-4 text-sm leading-relaxed text-neutral-700">
        You&rsquo;re no longer a member of &ldquo;{safeName}&rdquo;.
      </p>
      <div className="mt-6 flex justify-end">
        <Button type="button" variant="primary" chrome="compact" onClick={onClose}>
          OK
        </Button>
      </div>
    </MonolithBoardModal>
  );
}
